/**
 * Uses Swiper package to create a carousel for product media
 * More info: https://swiperjs.com//
 */
if (!customElements.get('product-media')) {
  class ProductMedia extends HTMLElement {
    constructor() {
      super();

      this.swiperInitialized = false;
      this.selectors = {
        slider: '[data-slider]',
      };
      this.breakpoints = {
        desktop: 749,
      };
      this.settings = {
        elements: {
          slider: this.querySelector(this.selectors.slider),
        },
        instances: {
          slider: null,
        },
        options: {
          slider: {
            pagination: {
              el: '.swiper-pagination',
              type: 'bullets',
            },
            autoHeight: true,
            breakpoints: {
              [this.breakpoints.desktop]: {
                allowTouchMove: false,
                pagination: false,
                autoHeight: false,
              },
            },
          },
        },
      };
    }

    connectedCallback() {
      this.init();

      window.addEventListener(
        'resize',
        debounce(() => {
          this.initSwiper();
        }, 300),
      );
    }

    init() {
      this.initSwiper();
    }

    initSwiper() {
      if (window.innerWidth <= this.breakpoints.desktop) {
        if (this.swiperInitialized || !this.settings.elements.slider) return;

        this.swiperInitialized = true;

        this.settings.instances.slider = new Swiper(
          this.settings.elements.slider,
          this.settings.options.slider,
        );

        this.settings.instances.slider.on('slideChange', () => {
          window.pauseAllMedia();
        });
      } else if (this.swiperInitialized) {
        this.settings.instances.slider.destroy();
        this.swiperInitialized = false;
      }
    }
  }

  customElements.define('product-media', ProductMedia);
}
